import { createRoot } from 'react-dom/client'
import { ChakraProvider } from '@chakra-ui/react'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { theme } from './styles/theme'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './libs/queryClient'
import Clarity from '@microsoft/clarity'
import ErrorBoundary from './pages/Error'

import './styles/global.css'
import './styles/front_icon.css'

const clarityId = import.meta.env.VITE_CLARITY_ID

if (clarityId) {
  try {
    Clarity.init(clarityId)
  } catch (error) {
    console.error('Falha ao inicializar o Microsoft Clarity:', error)
  }
}

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Elemento #root não encontrado')
}

try {
  createRoot(rootElement).render(
    <ErrorBoundary>
      <ChakraProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router}/>
        </QueryClientProvider>
      </ChakraProvider>
    </ErrorBoundary>
  )
} catch (error) {
  console.error('Falha ao iniciar a aplicação:', error)
  rootElement.innerHTML = `
    <div style="background:#fff;color:#222;font-family:Arial,sans-serif;margin:32px;padding:24px">
      Não foi possível iniciar o Gopass. Abra o console do navegador com Ctrl+Shift+I para ver o erro.
    </div>
  `
}

window.addEventListener('vite:preloadError', () => {
  console.log('Preload Error')
  window.location.reload() // for example, refresh the page
})
